import script from "./InspectorSetBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorSetBtn.vue?vue&type=script&setup=true&lang=js"

import "./InspectorSetBtn.vue?vue&type=style&index=0&id=1e96eae6&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e96eae6"]])

export default __exports__